import { actionTypes } from "./actions";

export const initialState = {
  formStepList: []
};

// ===========================|| COMMON REDUCER ||=========================== //

const formStepReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FORMTSTEP_GET_REQUEST:
      return {
        ...state,
        isFormStepLoading: true,
      };
    case actionTypes.FORMTSTEP_GET_RECEIVE:
      return {
        ...state,
        formStepList: action.payload.map((dt, index) => ({ ...dt, id: index })),
        isFormStepLoading: false,
      };
    case actionTypes.FORMTSTEP_GET_FAIL:
      return {
        ...state,
        isFormStepLoading: false,
        isFormStepFail: false,
      };
    default:
      return state;
  }
};

export default formStepReducer;
